import { UpgradeButton } from 'src/modules/ambient_solo/components/Payments/UpgradeButton';

export const PLGUsersCard = () => {
  return (
    <div className="overlay-screen fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[99] flex items-center justify-center">
      <div className="page-wrapper custom-modal-content">
        <div className="p-4 items-center">
          <div className="flex justify-center">
            <UpgradeButton
              text="This feature is not available in the free plan. Please click the
            button to upgrade to a paid plan."
              analyticsEvent="Clicked Upgrade Button In Templates Exchange"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
